
import {map, flatMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';


import { BaseService, AppSettingsService, AuthenticationService, ServiceManager } from 'iui-iconectiv-lib';
import { GenericResponse } from '../shared';


const GET_SERVICE_AGREEMENT = '/api/serviceagreement';
const POST_SERVICE_ACCEPTANCE = '/api/account/serviceacceptance';


@Injectable()
export class ServiceAgreementService extends BaseService {

  constructor(
    serviceManager: ServiceManager,
    private http: HttpClient,
    private appSettings: AppSettingsService,
    private authService: AuthenticationService,
  ) {

    super(serviceManager);

  }


  /**
   * obtain service agreement
   */
  getServiceAgreement(): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + GET_SERVICE_AGREEMENT;

      return this.http.get(url, {
        headers: new HttpHeaders()
          .append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken()),
        responseType: 'text'
      }).pipe(map(res => {
        const r = this.parseToType<GenericResponse>(res);
        return r;
      }));
    })));
  }

  /**
   * save account admin user's acceptance
   */
  postServiceAgreementAcceptance(): Observable<any> {
    return this.emitObservable(this.appSettings.getSettings().pipe(flatMap(settings => {
      const url = this.getServer(settings) + POST_SERVICE_ACCEPTANCE;

      return this.http.post(url, null, {
        headers: new HttpHeaders().append('Content-Type', 'application/json')
          .append('Authorization', this.authService.getToken())
      });
    })));
  }

}
